export const STORE_LOCATIONS = [
  {
    path: 'toronto',
    country: 'Canadian',
    seo: {
      title: 'Toronto Optometrist Near Me & Sunglasses Store in Toronto',
      description:
        "Toronto prescription glasses,  blue light filter glasses, sunglasses and frames it's with a 10-year warranty and Dresden assurance in Dresden stores.",
      h1: 'Toronto Optometrist & Glasses Store'
    },
    key: 'Toronto',
    groupByCity: false
  },
  {
    path: 'hamilton-city',
    country: 'Canadian',
    seo: {
      title: 'Hamilton Glasses Store & Best Sunglasses Store in Hamilton',
      description:
        "Hamilton prescription glasses,  blue light filter glasses, sunglasses and frames it's with a 10-year warranty and Dresden assurance in Dresden stores.",
      h1: 'Glasses in Hamilton & Optometrist in Hamilton'
    },
    key: 'Hamilton',
    parentText: 'Hamilton City',
    groupByCity: false
  },
  {
    path: 'nsw',
    country: 'Australian',
    seo: {
      title:
        'New South Wales Optometrist Near Me & Best Sunglasses Store in NSW',
      description:
        "New South Wales prescription glasses,  blue light filter glasses, sunglasses and frames it's with a 10-year warranty and Dresden assurance in Dresden stores.",
      h1: 'New South Wales Optometrist & Glasses Store'
    },
    key: 'NSW',
    groupByCity: true
  },
  {
    path: 'vic',
    country: 'Australian',
    seo: {
      title: 'Victoria Optometrist Near Me & Best Sunglasses Store in VIC',
      description:
        "Victoria (VIC) prescription glasses,  blue light filter glasses, sunglasses and frames it's with a 10-year warranty and Dresden assurance in Dresden stores.",
      h1: 'Optometrist in Victoria & Glasses Store'
    },
    groupByCity: true,
    key: 'VIC'
  },
  {
    path: 'qld',
    country: 'Australian',
    seo: {
      title: 'Queensland Glasses Store & Best Sunglasses Store in QLD',
      description:
        "Queensland (QLD) prescription glasses,  blue light filter glasses, sunglasses and frames it's with a 10-year warranty and Dresden assurance in Dresden stores.",
      h1: 'Queensland Optometrist & Glasses Store'
    },
    groupByCity: true,
    key: 'QLD'
  }
];
